<template>
  <div class="flex-1 flex flex-col overflow-hidden">
    <Header :title="t.page_name" @childLang="useLang" />
    <main class="flex-1 overflow-x-hidden overflow-y-auto" style="background: var(--ice);">
      <div class="d2-home-content trial-bind-content">
        <div class="d2-card trial-bind-card">
          <div class="d2-card-title">
            <i class="fas fa-credit-card"></i>{{ t.page_name }}
          </div>
          <p class="trial-bind-lead">{{ t.lead }}</p>

          <div class="trial-bind-grid">
            <div class="trial-bind-panel">
              <div class="trial-bind-label">{{ t.trial_title }}</div>
              <div class="trial-bind-value">{{ info.expire_time || '-' }}</div>
              <p>{{ t.trial_desc }}</p>
            </div>
            <div class="trial-bind-panel">
              <div class="trial-bind-label">{{ t.plan_title }}</div>
              <div class="trial-bind-value">{{ planName }}</div>
              <p>{{ t.plan_desc.replace('{amount}', planAmountText) }}</p>
            </div>
            <div class="trial-bind-panel">
              <div class="trial-bind-label">{{ t.verify_title }}</div>
              <div class="trial-bind-value">TWD 6</div>
              <p>{{ t.verify_desc }}</p>
            </div>
          </div>

          <div class="trial-bind-terms">
            <label class="trial-bind-check">
              <input type="checkbox" v-model="agreeService" />
              <span>
                {{ t.agree_service_prefix }}
                <button type="button" class="trial-bind-link" @click.stop.prevent="openServicePrivacy">
                  <strong>{{ t.service_terms_text }}</strong>
                </button>
                {{ t.agree_service_suffix }}
              </span>
            </label>
            <label class="trial-bind-check">
              <input type="checkbox" v-model="agreeRenewal" />
              <span>{{ t.agree_renewal.replace('{amount}', planAmountText) }}</span>
            </label>
            <ul>
              <li>{{ t.notice_1 }}</li>
              <li>{{ t.notice_2 }}</li>
              <li>{{ t.notice_3 }}</li>
            </ul>
          </div>

          <div class="d2-btn-row trial-bind-actions">
            <button class="d2-btn d2-btn-yellow" :disabled="!canSubmit || loading" @click="startBindCard">
              <i class="fas fa-lock"></i>
              <span>{{ loading ? t.processing : t.bind_button }}</span>
            </button>
          </div>
        </div>
      </div>
    </main>

    <Dialog v-model:visible="showEcpayModal" class="w-4/5 lg:w-3/5 bg-white shadow rounded-xl" :modal="true" :closable="true">
      <template #header>
        <div class="w-full d2-dialog-header-title">{{ t.ecpay_title }}</div>
      </template>
      <div class="py-4">
        <div id="ECPayPayment" style="min-height: 400px;"></div>
      </div>
      <template #footer>
        <div class="w-full d2-btn-row" style="justify-content: flex-end;">
          <button class="d2-btn-ghost" @click="showEcpayModal = false">{{ t.cancel_button }}</button>
          <button class="d2-btn d2-btn-yellow" :disabled="submittingPayment" @click="submitEcpayPayment">
            {{ submittingPayment ? t.processing : t.confirm_button }}
          </button>
        </div>
      </template>
    </Dialog>
    <InvoiceDialog
      v-bind:lang="showLang[selectLang]"
      v-bind:invoiceData="invoiceData"
      v-model:show="showInvoiceModal"
      @invoiceSaved="onInvoiceSaved"
    />
    <Dialog v-model:visible="showServicePrivacyModal" class="w-11/12 lg:w-3/5 bg-white shadow rounded-xl" :modal="true" :closable="true">
      <template #header>
        <div class="w-full d2-dialog-header-title">{{ t.service_terms_text }}</div>
      </template>
      <iframe class="trial-bind-service-frame" :src="servicePrivacyUrl" title="service-privacy"></iframe>
    </Dialog>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Dialog from 'primevue/dialog'
import InvoiceDialog from '@/components/Dialog/InvoiceDialog.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import axios from 'axios'
import Qs from 'qs'
import { API_BASE_URL, SITE_BASE_URL } from '@/api/config'
import lang from '@/language/lang.json'

export default {
  name: 'TrialBindCard',
  components: {
    Header,
    Dialog,
    InvoiceDialog
  },
  data() {
    return {
      selectLang: 'zh-TW',
      showLang: lang,
      info: {},
      agreeService: false,
      agreeRenewal: false,
      loading: false,
      showEcpayModal: false,
      ecpaySdkLoaded: false,
      submittingPayment: false,
      pendingPaymentData: null,
      showInvoiceModal: false,
      invoiceData: {
        identifier: '',
        name: '',
        address: '',
        mobile: '',
        email: ''
      },
      pendingStartBindAfterInvoice: false,
      showServicePrivacyModal: false
    }
  },
  computed: {
    t() {
      return this.showLang[this.selectLang]['views']['TrialBindCard']
    },
    canSubmit() {
      return this.info.member_id && this.agreeService && this.agreeRenewal
    },
    planName() {
      return this.info.plan_title || this.t.default_plan_name
    },
    planAmountText() {
      const amount = this.info.plan_amount || this.info.PeriodAmount || ''
      const currency = this.info.currency || 'TWD'
      return amount ? `${currency} ${amount}` : this.t.plan_amount_unknown
    },
    servicePrivacyUrl() {
      return `${SITE_BASE_URL}/index.php/index/service_privacy/${this.selectLang}?embed=1`
    }
  },
  created() {
    this.init()
  },
  methods: {
    useLang(value) {
      this.selectLang = value
    },
    async init() {
      try {
        const langResponse = await axios.post(`${API_BASE_URL}/get_lang.php`, Qs.stringify({
          s_code: this.$route.params.id
        }))
        if (langResponse.data.status === 'success') {
          this.selectLang = langResponse.data.return_data
        }

        const infoResponse = await axios.post(`${API_BASE_URL}/trial_bind_info.php`, Qs.stringify({
          s_code: this.$route.params.id,
          type: this.$route.params.type
        }), { withCredentials: true })

        if (infoResponse.data.status === 'success') {
          this.info = infoResponse.data.return_data
          if (this.info.connection_card) {
            this.goOnboardingLinkAccount()
          }
        } else {
          Swal.fire(this.t.login_error_title, infoResponse.data.info || this.t.login_error_text, 'error')
        }
      } catch (error) {
        Swal.fire(this.t.login_error_title, this.t.login_error_text, 'error')
      }
    },
    async startBindCard() {
      if (!this.canSubmit) {
        Swal.fire(this.t.notice_title, this.t.must_agree, 'warning')
        return
      }

      const hasInvoiceData = await this.checkInvoiceData()
      if (!hasInvoiceData) {
        this.pendingStartBindAfterInvoice = true
        this.showInvoiceModal = true
        return
      }

      await this.proceedBindCard()
    },
    async checkInvoiceData() {
      try {
        const response = await axios.post(`${API_BASE_URL}/data/invoice_check.php`, Qs.stringify({
          s_code: this.$route.params.id
        }))

        if (response.data.status === 'success') {
          this.invoiceData = response.data.invoiceData || this.invoiceData
          return !!response.data.hasInvoiceData
        }
      } catch (error) {
        return false
      }

      return false
    },
    onInvoiceSaved() {
      this.showInvoiceModal = false
      if (this.pendingStartBindAfterInvoice) {
        this.pendingStartBindAfterInvoice = false
        this.proceedBindCard()
      }
    },
    openServicePrivacy() {
      this.showServicePrivacyModal = true
    },
    async proceedBindCard() {
      this.loading = true
      try {
        const consentTime = new Date().toISOString()
        const response = await axios.post(`${SITE_BASE_URL}/udnapi/account_info/create_hidden_data_v3.php`, Qs.stringify({
          member_id: this.info.member_id,
          currency: 'TWD',
          price: 6,
          plan_title: this.t.verify_order_title,
          plan_id: 2,
          hash: this.$route.params.id,
          trial_bind: 1,
          consent_version: 'trial-auto-renewal-2026-08-06',
          consent_screen: 'TrialBindCard',
          consent_plan_id: 2,
          consent_time: consentTime
        }))

        this.loading = false
        if (response.data.status === 'success') {
          this.pendingPaymentData = response.data.data
          this.loadEcpaySdk(response.data.data)
        } else {
          Swal.fire(this.t.payment_error_title, response.data.info || this.t.payment_error_text, 'error')
        }
      } catch (error) {
        this.loading = false
        Swal.fire(this.t.payment_error_title, this.t.payment_error_text, 'error')
      }
    },
    loadEcpaySdk(data) {
      this.showEcpayModal = true

      if (this.ecpaySdkLoaded) {
        this.initEcpayPayment(data.Token)
        return
      }

      if (!window.jQuery) {
        const jqueryScript = document.createElement('script')
        jqueryScript.src = 'https://code.jquery.com/jquery-3.5.1.min.js'
        jqueryScript.onload = () => this.loadEcpaySdkScript(data)
        document.head.appendChild(jqueryScript)
      } else {
        this.loadEcpaySdkScript(data)
      }
    },
    loadEcpaySdkScript(data) {
      const script = document.createElement('script')
      script.src = data.SdkUrl
      script.onload = () => {
        this.ecpaySdkLoaded = true
        this.initEcpayPayment(data.Token)
      }
      script.onerror = () => {
        this.showEcpayModal = false
        Swal.fire(this.t.payment_error_title, this.t.sdk_load_error, 'error')
      }
      document.head.appendChild(script)
    },
    initEcpayPayment(token) {
      this.$nextTick(() => {
        const container = document.getElementById('ECPayPayment')
        if (!container || !window.ECPay) {
          return
        }

        const serverType = SITE_BASE_URL.indexOf('test.') > -1 ? 'Stage' : 'Prod'
        const self = this
        window.ECPay.initialize(serverType, 1, function(errMsg) {
          if (errMsg) {
            Swal.fire(self.t.payment_error_title, errMsg, 'error')
            return
          }

          var ecpayLang = self.selectLang === 'en-US' ? window.ECPay.Language.enUS : window.ECPay.Language.zhTW
          window.ECPay.addBindingCard(token, ecpayLang, function(bindErrMsg) {
            if (bindErrMsg) {
              Swal.fire(self.t.payment_error_title, bindErrMsg, 'error')
            }
          })
        })
      })
    },
    submitEcpayPayment() {
      if (!window.ECPay || typeof window.ECPay.getBindCardPayToken !== 'function') {
        Swal.fire(this.t.payment_error_title, this.t.sdk_method_error, 'error')
        return
      }

      this.submittingPayment = true
      window.ECPay.getBindCardPayToken((paymentInfo, errMsg) => {
        if (errMsg) {
          this.submittingPayment = false
          Swal.fire(this.t.payment_error_title, errMsg, 'error')
          return
        }

        if (paymentInfo) {
          this.completeBindCardPayment(paymentInfo)
        }
      })
    },
    async completeBindCardPayment(paymentInfo) {
      try {
        const response = await axios.post(`${SITE_BASE_URL}/udnapi/account_info/create_bindcard_payment.php`, Qs.stringify({
          bind_card_pay_token: paymentInfo.BindCardPayToken,
          merchant_trade_no: paymentInfo.MerchantTradeNo,
          member_id: this.info.member_id,
          trial_bind: 1
        }))

        this.submittingPayment = false
        if (response.data.status === 'success') {
          if (response.data.need3D && response.data.threeDURL) {
            window.location.href = response.data.threeDURL
            return
          }

          this.trackTrialBindCompleteRegistration()
          this.showEcpayModal = false
          Swal.fire({
            icon: 'success',
            title: this.t.success_title,
            text: this.t.success_text,
            confirmButtonText: this.t.confirm_button
          }).then(() => this.goOnboardingLinkAccount())
        } else {
          Swal.fire(this.t.payment_error_title, response.data.info || this.t.payment_error_text, 'error')
        }
      } catch (error) {
        this.submittingPayment = false
        Swal.fire(this.t.payment_error_title, this.t.payment_error_text, 'error')
      }
    },
    trackTrialBindCompleteRegistration() {
      if (typeof window.fbq !== 'function') {
        return
      }

      const eventData = {
        content_name: 'trial_bind_card',
        trial_bind: 1,
        plan_id: 2,
        value: 6,
        currency: 'TWD'
      }

      window.fbq('trackSingle', '2394962364159595', 'CompleteRegistration', eventData)
      window.fbq('trackSingle', '1489697366069847', 'CompleteRegistration', eventData)
    },
    goOnboardingLinkAccount() {
      window.location.href = `/onboarding-link-account/${this.$route.params.type}/${this.$route.params.id}`
    }
  }
}
</script>

<style lang="scss" scoped>
.trial-bind-card {
  width: 100%;
  max-width: 1080px;
  margin: 0;
}

.trial-bind-content {
  width: 100%;
  min-height: calc(100vh - 96px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.trial-bind-lead {
  margin: 8px 0 20px;
  color: var(--slate);
  line-height: 1.7;
}

.trial-bind-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.trial-bind-panel {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  padding: 16px;
  background: #fff;
}

.trial-bind-panel p {
  margin: 8px 0 0;
  color: var(--slate);
  line-height: 1.6;
}

.trial-bind-label {
  color: var(--gray);
  font-size: 13px;
  font-weight: 600;
}

.trial-bind-value {
  margin-top: 6px;
  color: var(--black);
  font-size: 22px;
  font-weight: 700;
}

.trial-bind-terms {
  margin-top: 18px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  padding: 16px;
  background: #f8fafc;
}

.trial-bind-check {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  color: var(--black);
  line-height: 1.6;
  margin-bottom: 10px;
}

.trial-bind-check input {
  margin-top: 5px;
}

.trial-bind-link {
  display: inline;
  border: 0;
  padding: 0;
  background: transparent;
  color: #2563ea;
  cursor: pointer;
  text-decoration: underline;
}

.trial-bind-service-frame {
  width: 100%;
  height: 68vh;
  border: 0;
  display: block;
}

.trial-bind-terms ul {
  margin: 10px 0 0 20px;
  color: var(--slate);
  line-height: 1.7;
}

.trial-bind-actions {
  justify-content: flex-end;
  margin-top: 20px;
}

.trial-bind-actions .d2-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .trial-bind-content {
    min-height: auto;
    align-items: flex-start;
  }

  .trial-bind-grid {
    grid-template-columns: 1fr;
  }

  .trial-bind-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }
}
</style>













